import React from 'react';

const FaceShapeCard = ({ title, description, imageSrc, backgroundColor }) => {
  return (
    <div className={`rounded-lg overflow-hidden shadow-md ${backgroundColor || 'bg-white'}`}>
      <div className="p-4">
        <h3 className="text-lg font-semibold mb-2">{title} Face</h3>
        <p className="text-sm text-gray-600">{description}</p>
      </div>
      {imageSrc && (
        <div className="h-48 bg-gray-200 flex items-center justify-center">
          <img 
            src={imageSrc} 
            alt={`${title} face shape`} 
            className="h-full w-full object-cover" 
          />
        </div>
      )}
    </div>
  );
};

const FaceShapeInfo = () => {
  const faceShapes = [
    {
      title: 'Oval',
      description: 'The oval face is considered the ideal shape because of its balanced proportions. The forehead is slightly wider than the chin, and the face length is about one and a half times the width.',
      backgroundColor: 'bg-faceShapes-oval bg-opacity-10'
    },
    {
      title: 'Round',
      description: 'Round face shapes have curved lines with the width and length in similar proportions and no sharp angles. Cheeks are typically the widest part of the face.',
      backgroundColor: 'bg-faceShapes-round bg-opacity-10'
    },
    {
      title: 'Square',
      description: 'Square faces have a strong jaw and a broad forehead, with the width and length in similar proportions. The jawline is defined and angular.',
      backgroundColor: 'bg-faceShapes-square bg-opacity-10'
    },
    {
      title: 'Heart',
      description: 'Heart-shaped faces have a wider forehead and cheekbones with a narrow jawline and chin. The face typically tapers to a point at the chin.',
      backgroundColor: 'bg-faceShapes-heart bg-opacity-10'
    },
    {
      title: 'Diamond',
      description: 'Diamond faces have narrow foreheads and jawlines with cheekbones at the widest point. The face has angular features with defined cheekbones.',
      backgroundColor: 'bg-faceShapes-diamond bg-opacity-10'
    },
    {
      title: 'Oblong',
      description: 'Oblong faces are longer than they are wide with a long straight cheek line. The forehead, cheeks, and jawline are similar in width.',
      backgroundColor: 'bg-faceShapes-oblong bg-opacity-10'
    }
  ];

  return (
    <div className="mt-8">
      <h2 className="text-2xl font-bold mb-4 text-center">Face Shape Guide</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {faceShapes.map((shape) => (
          <FaceShapeCard
            key={shape.title}
            title={shape.title}
            description={shape.description}
            imageSrc={shape.imageSrc}
            backgroundColor={shape.backgroundColor}
          />
        ))}
      </div>
      <div className="mt-6 text-sm text-center text-gray-500">
        Knowing your face shape can help you choose the most flattering hairstyles, glasses, and accessories.
      </div>
    </div>
  );
};

export default FaceShapeInfo;